import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import HelpItem1 from './HelpItens/HelpItem1.js'
import HelpItem2 from './HelpItens/HelpItem2.js'
import HelpItem3 from './HelpItens/HelpItem3.js'
import HelpItem4 from './HelpItens/HelpItem4.js'
import HelpItem5 from './HelpItens/HelpItem5.js'
import HelpItem6 from './HelpItens/HelpItem6.js'
import HelpItem7 from './HelpItens/HelpItem7.js'
// import HelpItem8 from './HelpItens/HelpItem8.js'

const Help = forwardRef((props, ref) => {
  return (
    <section id={props.id} ref={ref} className='home-section help'>
      <div className='container-fluid bg-color-ui-4'>
        <div className='container'>
          <div className='row py-3'>
            <div className='col-12'>
              <h3 title='está com dúvidas? veja nossas perguntas frequentes.' tabIndex='0'>está com dúvidas? veja nossas perguntas frequentes.</h3>
              <div className='flexible-items-container'>
                <HelpItem1 />
                <HelpItem2 />
                <HelpItem3 />
                <HelpItem4 />
                <HelpItem5 />
                <HelpItem6 />
                <HelpItem7 />
                {/* <HelpItem8 /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
})

Help.propTypes = {
  id: PropTypes.string
}

export default Help



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/components/Help.js